<template>
  <div class="yx-phone">
    <div class="login-content">
      <div class="login-title-box">
        <template v-if="platformKey == 'yuanxi'">
          <div class="login-icon">
            <img src="~@/assets/images/yuanxi/icon.png">
          </div>
          <div class="logo-text">元习</div>
          <span v-if="!is_register && !is_forget">学会如何学习</span>
        </template>
        <img class="login-image" :src="platforms[platformKey].logo" alt="" v-else>
      </div>

      <template v-if="!is_register && !is_forget && !is_wechat">
        <div class="login-input-box fadeIn">
          <div class="lp-item" v-if="device == 'web'">
            <a-button class="my-button wx-button" @click="wechat_login()">
              <img src="~@/assets/images/yuanxi/wechat.png" alt="">
              <span>微信一键登录</span>
            </a-button>
          </div>
          <div class="login-divider">或使用账号登录</div>

          <div class="lp-item">
            <a-input v-model="account" class="my-input" placeholder="手机号" :maxLength="20" />
          </div>
          <div class="lp-item">
            <a-input-password v-model="password" type="password" placeholder="密码" :maxLength="20" />
          </div>
          <div class="lp-info">
            <a-checkbox class="rememberMe" v-model:checked="rememberMe">记住我</a-checkbox>
            <div class="a-text" @click="is_forget = true">忘记密码？</div>
          </div>

          <div class="lp-item">
            <a-button class="my-button" type="primary" :loading="logining" @click="login()">登录</a-button>
          </div>
        </div>

        <div class="info-box">
          <span>还没有账号？</span>
          <span class="a-text info-register" @click="is_register = true">立即注册</span>
        </div>
      </template>

      <!-- 注册 -->
      <template v-if="is_register">
        <div class="login-input-box register-box fadeIn">
          <div class="lp-item">
            <a-input v-model="formRegister.phone" class="my-input" placeholder="请输入手机号" :maxLength="11" />
          </div>
          <div class="lp-item">

            <div class="code-box">
              <a-input v-model="formRegister.code" class="my-input" placeholder="请输入验证码" suffix :maxLength="6" />
              <!-- 倒计时 -->
              <span class="get-code" v-if="count == 0" @click="getPhoneCode">获取验证码</span>
              <span class="get-code" v-else>{{ count }}秒后重试</span>
            </div>
          </div>
          <div class="lp-item">
            <a-input-password v-model="formRegister.password" type="password" placeholder="请输入密码" :maxLength="20" />
          </div>
          <div class="lp-item">
            <a-input-password v-model="formRegister.checkPassword" type="password" placeholder="请输入再次输入密码"
              :maxLength="20" />
          </div>
          <div class="lp-item">
            <a-input v-model="formRegister.nickName" class="my-input" placeholder="请输入姓名" :maxLength="20" />
          </div>
          <a-button class="lp-button my-button" type="primary" :loading="registering"
            @click="checkCode()">确认注册</a-button>
        </div>
        <div class="info-box">
          <div class="a-text" @click="returnLogin()">返回登陆</div>
        </div>
      </template>
      <!-- 忘记密码 -->
      <template v-if="is_forget">
        <div class="login-input-box forget-box fadeIn">
          <div class="fadeIn" v-if="forgetStep == 1">
            <div class="lp-item">
              <a-input v-model="formRegister.phone" class="my-input" placeholder="请输入手机号" :maxLength="11" />
            </div>
            <div class="lp-item">
              <div class="code-box">
                <a-input v-model="formRegister.code" class="my-input" placeholder="请输入验证码" suffix :maxLength="6" />
                <!-- 倒计时 -->
                <span class="get-code" v-if="count == 0" @click="getPhoneCode">获取验证码</span>
                <span class="get-code" v-else>{{ count }}秒后重试</span>
              </div>
            </div>
            <a-button class="lp-button my-button" type="primary" :loading="registering"
              @click="checkCode()">下一步</a-button>
          </div>
          <div class="fadeIn" v-if="forgetStep == 2">
            <div class="lp-item">
              <a-input-password v-model="formRegister.password" type="password" placeholder="请输入密码" :maxLength="20" />
            </div>
            <div class="lp-item">
              <a-input-password v-model="formRegister.checkPassword" type="password" placeholder="请输入再次输入密码"
                :maxLength="20" />
            </div>
            <a-button class="lp-button my-button" type="primary" :loading="editPasswording"
              @click="editPassword()">确认修改</a-button>
          </div>
        </div>
        <div class="info-box">
          <div class="a-text" @click="returnLogin()">返回登陆</div>
        </div>
      </template>
    </div>
    <!-- 公安备案 -->
    <div style="text-align: center;margin:0 auto;font-size: 12px;" v-if="platformKey == 'yuanxi'">
      <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52010302003322"
        style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img
          src="~@/assets/images/public_security.png" style="float:left;" />
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color: #333333;">贵公网安备
          52010302003322号</p>
      </a>
    </div>
  </div>
</template>

<script>
import { addQueryString } from '@/util/url';
import { PASSPORT_CLIENT_SERVER, WX_OPEN_SERVER } from '@/config/url'
import { M_APPID } from '@/config/wx'
import { platforms } from '@/config/constants.js';

export default {
  name: "yx_phone",
  props: {
    redirectURI: String,
  },
  data() {
    return {
      userGuid: '',
      formRegister: {
        phone: '',
        password: '',
        checkPassword: '',
        nickName: '',
      },

      loading: true,
      is_wechat: false,
      is_register: false,
      is_forget: false,

      logining: false,
      registering: false,
      editPasswording: false,

      rememberMe: false,

      account: '',
      password: '',

      count: 0,
      forgetStep: 1,
      device: 'web',
      pageContent: null,

      platformKey: 'yuanxi',
      platforms: platforms,
    }
  },
  async mounted() {
    document.title = '元习 - 新一代数字教材平台'
    let path = this.$route.path;
    this.platformKey = path ? path.replace('/', '') : 'yuanxi';
    const platform = this.platforms[this.platformKey];
    document.title = platform.title;

    document.addEventListener('UniAppJSBridgeReady', () => {
      uni.getEnv((res) => {
        if (res.plus) {
          this.device = 'app'
        }
      });
    });

    this.fillRemember();
  },
  methods: {
    //账号密码登录
    async login() {
      let msg = '';
      if (!this.account || !this.password) msg = '请输入正确的账号密码';
      if (msg) return this.$message.warning(msg);

      this.judgeRemember();

      this.logining = true;
      //登录
      let res = await this.$api.passport.auth({ username: this.account, password: this.password });
      this.logining = false;

      if (res.status != 1) return this.$message.warning('用户名或密码不正确');
      if (this.device == 'app') {
        uni.postMessage({
          data: {
            action: 'saveUser',
            data: { username: this.account, password: this.password }
          }
        });
      }
      window.localStorage.setItem("LESSONPLAY_TOKEN", res.token);
      this.$message.success('登陆成功');
      location.href = addQueryString(this.redirectURI, 'token', res.token);
    },
    //微信登陆
    async wechat_login() {
      const wxApiRedirectURI = `${PASSPORT_CLIENT_SERVER}/wx?redirectURI=${this.redirectURI}`
      location.href = `${WX_OPEN_SERVER}/connect/oauth2/authorize?appid=${M_APPID}&redirect_uri=${wxApiRedirectURI}&response_type=code&scope=snsapi_userinfo&state=strict#wechat_redirect`
    },

    //获取验证码
    async getPhoneCode() {
      let formRegister = this.formRegister;
      let count = this.count;

      if (!formRegister.phone || formRegister.phone.length != 11) return this.$message.warning('请先输入正确的手机号');
      count = 60;
      count -= 1;
      this.count = count;

      let that = this;
      let countTime = setInterval(() => {
        count -= 1;
        that.count = count;
        if (count == 0) {
          clearInterval(countTime);
        }
      }, 1000);
      this.$message.success('短信已发送，请注意查收');

      let res = await this.$api.account.sendSms(formRegister.phone);
      if (res.code != 1) return this.$message.error(res.msg);
      formRegister.codeGuid = res.data.PK_CodeGuid;
    },
    //验证忘记密码
    async checkCode() {
      if (this.registering) return;
      let { phone, codeGuid, code } = this.formRegister;

      let msg = ``;
      if (!phone || phone.length != 11) msg = '请输入正确的手机号';
      else if (!codeGuid) msg = '请先获取验证码';
      if (msg) return this.$message.warning(msg);

      this.registering = true;
      //先验证验证码
      let res = await this.$api.account.checkcode(codeGuid, code);
      if (res.code != 1) {
        this.registering = false;
        return this.$message.error(res.msg);
      }

      if (this.is_register) this.register();
      else {
        //找到用户
        let userList = await this.$api.account.getClientByUser(phone).then(res => res.data || []);
        this.registering = false;
        if (userList.length == 0) {
          return this.$message.warning("未找到该用户，请确认手机号是否正确");
        }
        this.userGuid = userList[0].PK_UserGuid;
        this.forgetStep = 2;
      }
    },
    //确定注册
    async register() {
      let { phone, password, checkPassword, nickName } = this.formRegister;
      let msg = '';

      if (!/^1[3456789]\d{9}$/.test(phone)) msg = '请输入正确的手机号';
      else if (!password || password.length < 6) msg = '密码不符合规则，请输入6位以上密码';
      else if (checkPassword != password) msg = '两次输入的密码不一致';
      else if (!nickName) msg = '请输入姓名';
      if (msg) return this.$message.warning(msg);

      nickName = nickName.trim();
      let res = await this.$api.account.register({ Name: phone, Phone: phone, Password: password, NickName: nickName });
      this.registering = false;
      if (res.status != 1) {
        this.formRegister.code = '';
        this.formRegister.codeGuid = '';
        return this.$message.error(res.err);
      }

      this.$message.success('注册成功');
      this.returnLogin();
    },
    //修改密码
    async editPassword() {
      let editPasswording = this.editPasswording;
      if (editPasswording) return;
      let { password, checkPassword } = this.formRegister;

      let msg = '';
      if (!password) msg = '请输入新密码';
      else if (checkPassword.length < 6) msg = '请至少输入6位密码';
      else if (!checkPassword) msg = '请再次输入新密码';
      else if (password != checkPassword) msg = '两次输入的密码不一致';

      if (msg) return this.$message.warning(msg);

      editPasswording = true;
      let res = await this.$api.account.setNewPassword({
        PK_UserGuid: this.userGuid,
        Password: password
      });
      editPasswording = false;
      if (res.status != 1) return this.$message.error(res.message);

      this.$message.success('密码重置成功');
      this.forgetStep = 1;
      this.returnLogin();
    },
    //返回登录
    async returnLogin() {
      this.is_wechat = false;
      this.is_register = false;
      this.is_forget = false;
      this.formRegister = {
        phone: '',
        password: '',
        checkPassword: '',
        nickName: '',
        codeGuid: '',
        code: ''
      }
      //隐藏二维码
      document.querySelector('iframe');
    },
    //修改标签图标
    changeFavicon(link) {
      let $favicon = document.querySelector('link[rel="icon"]');
      if ($favicon !== null) {
        $favicon.href = link;
      } else {
        $favicon = document.createElement("link");
        $favicon.rel = "icon";
        $favicon.href = link;
        document.head.appendChild($favicon);
      }
    },
    //记住密码
    judgeRemember() {
      const encryptedU = btoa(this.account);
      const encryptedP = btoa(this.password);

      if (this.rememberMe) {
        localStorage.setItem('encryptedU', encryptedU);
        localStorage.setItem('encryptedP', encryptedP);
      } else {
        localStorage.removeItem('encryptedU');
        localStorage.removeItem('encryptedP');
      }
    },
    //填入已记住密码
    fillRemember() {
      const encryptedU = localStorage.getItem('encryptedU');
      const encryptedP = localStorage.getItem('encryptedP');

      if (encryptedU && encryptedP) {
        this.account = atob(encryptedU);
        this.password = atob(encryptedP);
        this.rememberMe = true;
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "./login.scss";
</style>